import React, { useEffect, useState } from "react";
import "./style.css"
import {
  EarlyAccessWrapper,
  FormSection,
  ImageSection,
  Form,
} from "./EarlyAccess.style";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { registerUser, selectAllUsers } from "../../redux/slice/usersEarlyAccessRegistration";
import { selectAllAdverts } from "../../redux/slice/advertSlice";
import { advertProps } from "../../interfaces/interfaces.d";
import { styles } from "./styles"
import  useFormValidation  from "../../hooks/useFormValidation";
import { RegisterSuccessModal } from "../modal/RegisterSuccessModal";


export const EarlyAccess = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const dispatch = useDispatch()
  const initialState = {
    name: "",
    email: "",
    phone:"",
    advert:""
  };

  const [user, setUser] = useState(initialState);
  const [message, setMessage] = useState('');
  const [formErrors, setFormErrors] = useState<any>({});
  const [modalIsOpen, setIsOpen] = useState(false);



  const adverts = useSelector(selectAllAdverts);
  const users = useSelector(selectAllUsers)

  const handleChange = (evt:any) => {
    const value = evt.target.value;
    setUser({
      ...user,
      [evt.target.name]: value
    });
  }
  
  
  const useSaveUserDetail = async (e:any) => {
    e.preventDefault();
    setFormErrors(useFormValidation(user));
      if (user.name && user.email && user.phone && user.advert) {
          dispatch(
            registerUser(user.name, user.email, user.phone, user.advert)
          )
      }
      if(Object.keys(formErrors).length === 0){
      try {
        let res = await fetch("https://bonpellz.herokuapp.com/bonpellz/users/?referralCode", {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: user.name,
            email: user.email,
            phoneNumber: user.phone,
            hearAboutUs: user.advert,
          }),
        });
        let resJson = await res.json();
        if (res.status === 200) {
          setUser({...initialState});
          setIsOpen(true);
          setMessage("User created successfully");
        } else {
          setMessage("Some error occured");
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  

  const advertOptions = adverts.length > 0 && adverts.map((ad:advertProps) => (
        <option key={ad.id} value={ad.value} style={styles.option}>
            {ad.value}
        </option>
  ));





  return (
    <>
      <EarlyAccessWrapper>
        <div>
          <FormSection>
              <Form action="">
                <h1>Get early access</h1>
                <p>Your finest journey to financial Freedom</p>

                <div>
                  <label htmlFor="">FullName</label>
                  <p style={{color:"red", margin:"0", padding:"0"}}>{formErrors.name}</p>

                  <input 
                    type="text" 
                    placeholder="Enter your full name"
                    value={user.name}
                    name="name"
                    onChange={handleChange}
                     />
                </div>
                <div>
                  <label htmlFor="">Email Address</label>
                  <p style={{color:"red", margin:"0", padding:"0"}}>{formErrors.email}</p>
                  <input 
                    type="text" 
                    placeholder="YourEmail@gmail.com" 
                    value={user.email}
                    name="email"
                    onChange={handleChange}

                    />
                </div>
                <div>
                  <label htmlFor="">Phone number</label>
                  <p style={{color:"red" , margin:"0", padding:"0"}}>{formErrors.phone}</p>
                  <input 
                    type="text" 
                    placeholder="Enter your phone number" 
                    value={user.phone}
                    name="phone"
                    onChange={handleChange}

                    />
                </div>
                <div>
                  <label htmlFor="">How did you hear about us?</label>
                  <p style={{color:"red" , margin:"0", padding:"0"}}>{formErrors.advert}</p>
                  <div className='textarea' placeholder="">
                  {/* <SingleSelect/> */}
                  <select 
                    style={styles.select} 
                    id="advert" 
                    name="advert"
                    value={user.advert}
                    onChange={handleChange}
                    >
                    <option value="">Select</option>
                    {advertOptions}
                  </select>

                  </div>
                </div>
                <div>
                  <button onClick = {useSaveUserDetail}>Get early access now</button>
                </div>
              </Form>
          </FormSection>
          <ImageSection>
              <img src="img/bro.png" alt="" />
          </ImageSection>
        </div>
      </EarlyAccessWrapper>
      { 
        modalIsOpen && <RegisterSuccessModal
        modalIsOpen= { modalIsOpen }
         setIsOpen={ setIsOpen }
         />
      }
    </>
  );
};
